import { z } from 'zod';
import { STANDARD_CONTACT_ROLES } from '../enums';

export enum ContactRole {
  DRIVER = 'DRIVER',
  DISPATCH = 'DISPATCH',
}

export enum ContactMethodStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ContactCommunicationPreferenceStatus {
  ALLOWED = 'ALLOWED',
  DO_NOT_CONTACT = 'DO_NOT_CONTACT',
}

export enum ContactCommunicationPreferenceUpdatedVia {
  AI_AGENT = 'AI_AGENT',
  USER_ACTION = 'USER_ACTION',
}

export const ContactCommunicationPreferenceSchema = z.object({
  carrierOutreachId: z.string().uuid().nullish(),
  status: z.nativeEnum(ContactCommunicationPreferenceStatus),
  updatedAt: z.string().datetime({ offset: true }),
  updatedByUserId: z.string().uuid().nullish(),
  updatedVia: z.nativeEnum(ContactCommunicationPreferenceUpdatedVia),
});

export type ContactCommunicationPreference = z.infer<
  typeof ContactCommunicationPreferenceSchema
>;

export const ContactCommunicationPreferencesSchema = z.object({
  email: ContactCommunicationPreferenceSchema.optional(),
  phone: ContactCommunicationPreferenceSchema.optional(),
  sms: ContactCommunicationPreferenceSchema.optional(),
});

export type ContactCommunicationPreferences = z.infer<
  typeof ContactCommunicationPreferencesSchema
>;

export const makeStandardPhoneNumberSchema = () => {
  return z.object({
    countryCode: z.string(),
    number: z.string(),
    extension: z.string().optional(),
  });
};
const standardPhoneNumberSchema = makeStandardPhoneNumberSchema();
export type StandardPhoneNumber = z.infer<typeof standardPhoneNumberSchema>;

export const makeStandardContactSchema = () => {
  return z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    phone: z.string().optional(),
    structuredPhone: makeStandardPhoneNumberSchema().optional(),
    email: z.string().optional(),
    role: z.enum(STANDARD_CONTACT_ROLES).optional(),
  });
};
const standardContactSchema = makeStandardContactSchema();
export type StandardContact = z.infer<typeof standardContactSchema>;
